import { useEffect, useState } from 'react';
import './App.css';
import { priorityColors } from './Constants';

const alphabet = 'abcdefghijklmnopqrstuvwxyz';

const Question = ({
	id,
	questionNumber,
	question,
	options,
	answer,
	explanation,
	priority,
	showAnswers,
	onMisAnswering,
}) => {
	const [answeredSuccessfully, setAnsweredSuccessfully] = useState(null);

	useEffect(() => {
		answeredSuccessfully === false && onMisAnswering && onMisAnswering()
	}, [answeredSuccessfully])

	const handleOptionClick = optionIndex => {
		setAnsweredSuccessfully(optionIndex === answer);
	};

	let className = 'question ';

	if (answeredSuccessfully !== null) {
		className += answeredSuccessfully ? 'correct' : 'incorrect';
	}

	return (
		<div className={className} style={{ borderWidth: showAnswers ? 0 : 1 }}>
			<div
				style={{
					marginBottom: 30,
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'flex-start',
				}}
			>
				{/* <div
					className="smallCircle"
					style={{ backgroundColor: priorityColors[priority], marginRight: 4 }}
				/> */}
				<strong style={{ width: '95%' }}>{questionNumber + 1 + '. ' + question}</strong>
			</div>
			{options.map((option, index) => (
				<div key={index} style={{ marginBottom: 15 }}>
					<input
						type="radio"
						name={`question${id}`}
						value={index}
						onChange={() => handleOptionClick(index)}
						id={`question${id} option${index}`}
						disabled={answeredSuccessfully !== null || showAnswers}
					/>
					<label
						htmlFor={`question${id} option${index}`}
						style={{
							color:
								(answeredSuccessfully === false || showAnswers) && index === answer
									? 'rgb(1, 164, 118)'
									: 'inherit',
						}}
					>
						{' ' + alphabet[index] + '. ' + option}
					</label>
				</div>
			))}
			{answeredSuccessfully !== null && explanation && (
				<div className="explanationContainer">
					<div className="explanation">{explanation}</div>
				</div>
			)}
		</div>
	);
};

export default Question;
